import React from 'react'
import Cricle from './Cricle';

export default function Howsystem() {
  return (
    <>
      <div className='md:pt-40 pt-20 md:px-10 px-5 mx-auto items-center justify-center max-w-7xl'>
        <div data-aos="zoom-in-up" data-aos-delay="300" className='text-[#B7BDC6] items-center text-center justify-center mx-auto'>
          <h1 className='text-center items-center mx-auto justify-center lg:text-5xl text-3xl md:text-4xl text-[#dfc660]'>
            How does the platform work?
          </h1>
          <p className='md:pt-10 pt-3 md:text-base text-sm text-center items-center mx-auto justify-center max-w-3xl'>
            To ensure maximum privacy, our system never uses your Bitcoin to send to other users. On the other hand, our Vaulteras has a large pool of crypto currency, allowing us to send payments for almost any amount. After we have received your Bitcoin payment, we make a transfer to the specified recipient address from our pool. This means that your Bitcoin is not involved in this operation and is still stored in the system, and eventually replenishing the main pool for the subsequent payments. As a result, no one can track it, and the use of our web service is truly anonymous. Thanks to the constant filling of the reserve, the service operates in an automatic mode.
          </p>
          <div className="flex gap-8 text-center items-center md:mt-12 mt-8">
            <a 
              href="/select"
              className="text-[#d8bb6c] hover:bg-[#d8bb6c] hover:text-black font-bold items-center justify-center text-center mx-auto text-sm md:text-sm grow-0 relative md:h-12 h-10 font-sans px-20 flex border border-[#d8bb6c] rounded-sm uppercase shadow-2xl duration-500">
              Clean Coins
            </a>
          </div>
        </div>
        <div data-aos="zoom-in-up" data-aos-delay="300" className='text-[#B7BDC6] items-center lg:grid lg:grid-cols-2 pt-10'>
          <div className='block md:hidden lg:hidden justify-center'>
            <Cricle/>
          </div>
          <div className="items-center py-5 justify-center">
            <div className="mx-auto items-center">
              <div className="">
                <div data-aos="zoom-in-up" data-aos-delay="300" className="md:flex gap-8 items-center">
                  <svg 
                    className='md:w-auto w-12' version="1.0" xmlns="http://www.w3.org/2000/svg"
                    width="50.000000pt" height="50.000000pt"
                    viewBox="0 0 100.000000 100.000000"
                    preserveAspectRatio="xMidYMid meet">
                    <g transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)"
                      fill="#d8bb6c" stroke="none">
                      <path d="M735 971 c-9 -41 -19 -46 -55 -24 -30 17 -30 17 -57 -10 -27 -27 -27
                      -27 -9 -58 20 -34 14 -46 -24 -51 -22 -3 -25 -9 -28 -45 -3 -39 -1 -42 27 -48
                      40 -8 46 -20 27 -47 -23 -32 -20 -44 14 -68 28 -20 32 -20 52 -6 34 24 45 20
                      52 -19 7 -33 9 -35 47 -35 36 0 40 3 46 30 8 40 17 45 53 24 29 -18 30 -18 59
                      10 l30 29 -20 28 c-24 34 -19 45 22 54 28 6 30 9 27 48 -3 36 -6 42 -28 45
                      -38 5 -44 17 -24 51 18 31 18 31 -9 58 -27 27 -27 27 -58 9 -34 -20 -46 -14
                      -51 24 -3 22 -9 25 -45 28 -39 3 -42 1 -48 -27z m60 -39 c8 -37 54 -56 85 -35
                      27 19 38 9 17 -15 -25 -27 -4 -78 35 -86 35 -7 37 -26 3 -26 -36 0 -59 -55
                      -37 -88 19 -29 10 -38 -18 -19 -32 23 -79 4 -87 -34 -7 -36 -23 -38 -23 -4 0
                      36 -54 59 -88 38 -30 -19 -39 -10 -20 19 22 33 -1 88 -37 88 -35 0 -31 17 5
                      25 20 4 30 13 30 25 0 10 4 22 10 25 6 4 3 16 -6 31 -21 31 -12 41 19 21 34
                      -22 87 1 87 38 0 34 17 32 25 -3z" fill='#DFC660'/>
                      <path d="M725 835 c-40 -39 -27 -104 26 -125 33 -14 62 -6 89 23 44 46 5 127
                      -60 127 -19 0 -40 -9 -55 -25z m85 -30 c26 -32 -13 -81 -47 -59 -35 22 -23 74
                      17 74 10 0 23 -7 30 -15z" fill='#DFC660'/>
                      <path d="M104 815 l-25 -25 3 -255 3 -255 -28 0 c-34 0 -43 -21 -27 -61 25
                      -58 30 -59 470 -59 440 0 445 1 470 59 16 40 7 61 -27 61 l-28 0 3 141 c3 139
                      3 140 -17 129 -19 -10 -21 -20 -21 -128 0 -79 -4 -122 -12 -130 -17 -17 -719
                      -17 -736 0 -17 17 -17 479 0 496 8 8 67 12 199 12 178 0 187 1 192 20 5 20 0
                      20 -194 20 -200 0 -200 0 -225 -25z m826 -579 c0 -3 -7 -12 -16 -20 -13 -14
                      -65 -16 -414 -16 -349 0 -401 2 -414 16 -9 8 -16 17 -16 20 0 2 193 4 430 4
                      237 0 430 -2 430 -4z"/>
                    </g>
                  </svg>
                  <div className="">
                    <h1 className='text-[#eaecef] py-2 md:text-lg font-semibold'>Algorithms</h1>
                    <p className='text-sm text-[#B7BDC6]'>
                      When you send us Bitcoins, we refine them using our custom made cryptographic algorithms.
                    </p>
                  </div>
                </div>
                <div data-aos="zoom-in-up" data-aos-delay="300" className="md:flex gap-8 items-center py-5">
                  <svg className='md:w-auto w-12' version="1.0" xmlns="http://www.w3.org/2000/svg"
                    width="40.000000pt" height="40.000000pt" viewBox="0 0 64.000000 64.000000"
                    preserveAspectRatio="xMidYMid meet">
                    <g transform="translate(0.000000,64.000000) scale(0.100000,-0.100000)"
                      fill="#d8bb6c" stroke="none">
                      <path d="M112 600 c-20 -20 -32 -44 -36 -75 -7 -42 -9 -45 -37 -45 -38 0 -34
                      -24 4 -28 l27 -3 0 -110 0 -109 -31 0 c-38 0 -35 -24 4 -28 23 -3 28 -9 33
                      -43 10 -59 51 -96 117 -104 72 -9 170 -2 174 11 3 8 -29 13 -101 16 -94 3
                      -108 6 -130 27 -18 17 -26 35 -26 57 0 28 4 33 27 36 39 4 42 28 4 28 l-31 0
                      0 109 0 110 27 3 c39 4 42 28 4 28 -29 0 -31 2 -31 38 0 27 7 45 23 60 22 21
                      32 22 223 22 254 0 242 8 246 -165 2 -99 6 -120 18 -120 12 0 16 16 18 75 5
                      122 -5 175 -39 210 l-31 30 -213 0 -213 0 -30 -30z"/>
                      <path d="M340 445 c0 -43 -24 -59 -60 -39 -52 28 -71 7 -20 -23 18 -10 30 -26
                      30 -38 0 -12 -12 -28 -30 -38 -51 -30 -32 -51 20 -23 36 20 60 4 60 -39 0 -24
                      5 -35 15 -35 11 0 15 12 15 49 0 40 -3 50 -20 54 -27 7 -36 35 -17 54 19 19
                      47 10 54 -17 7 -25 33 -27 33 -2 0 10 14 26 30 35 51 30 32 51 -20 23 -36 -20
                      -60 -4 -60 39 0 24 -5 35 -15 35 -10 0 -15 -11 -15 -35z"/>
                      <path d="M447 324 c-4 -4 -7 -15 -7 -25 0 -9 -6 -19 -12 -22 -10 -4 -10 -7 0
                      -18 15 -16 17 -176 2 -181 -13 -4 17 -68 32 -68 5 0 12 9 15 20 7 26 29 26 36
                      0 7 -26 27 -26 34 0 3 11 20 24 38 30 48 16 63 75 26 106 -11 10 -16 24 -14
                      35 8 30 -5 67 -26 74 -11 3 -21 16 -23 28 -4 29 -32 28 -36 0 -4 -29 -30 -30
                      -34 -1 -3 22 -19 33 -31 22z m122 -98 c4 -25 -24 -46 -61 -46 -25 0 -28 3 -28
                      36 l0 35 42 -3 c33 -2 44 -7 47 -22z m29 -100 c6 -28 -25 -46 -75 -46 -43 0
                      -43 0 -43 35 l0 36 57 -3 c48 -2 58 -6 61 -22z" fill='#d8bb6c'/>
                    </g>
                  </svg>
                  <div className="">
                    <h1 className='text-[#eaecef] py-2 md:text-lg font-semibold'>
                      Control Address
                    </h1>
                    <p className='text-[#B7BDC6] text-sm md:text-base max-w-lg'>
                      Once your coins are given a perfect mix, we send the refined coins back to you via a new address that you control.
                    </p>
                  </div>
                </div>
                <div data-aos="zoom-in-up" data-aos-delay="300" className="md:flex gap-8 items-center py-2">
                  <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                    width="40.000000pt" height="50.000000pt" viewBox="0 0 64.000000 64.000000"
                    preserveAspectRatio="xMidYMid meet">
                    <g transform="translate(0.000000,64.000000) scale(0.100000,-0.100000)"
                      fill="#d8bb6c" stroke="none">
                      <path d="M224 595 c-10 -25 4 -45 30 -45 30 0 40 13 31 40 -8 24 -53 28 -61 5z" fill='#d8bb6c'/>
                      <path d="M250 475 c0 -30 5 -55 10 -55 6 0 10 25 10 55 0 30 -4 55 -10 55 -5
                      0 -10 -25 -10 -55z"/>
                      <path d="M293 465 c0 -22 2 -30 4 -17 2 12 2 30 0 40 -3 9 -5 -1 -4 -23z" fill='#d8bb6c'/>
                      <path d="M235 396 c-24 -17 -15 -50 14 -54 39 -6 56 39 22 57 -13 7 -23 6 -36
                      -3z" fill='#d8bb6c'/>
                      <path d="M540 396 c-27 -33 18 -72 48 -42 13 13 14 20 6 34 -15 23 -38 26 -54
                      8z" fill='#d8bb6c'/>
                      <path d="M475 335 c-22 -14 -44 -27 -50 -29 -5 -2 -7 -7 -3 -11 8 -8 98 43 98
                      56 0 12 1 12 -45 -16z"/>
                      <path d="M163 324 c-24 -14 -43 -30 -43 -35 0 -11 100 43 100 54 0 12 -13 8
                      -57 -19z"/>
                      <path d="M290 342 c0 -10 43 -42 56 -42 10 0 -17 30 -38 41 -10 6 -18 6 -18 1z"/>
                      <path d="M50 286 c-27 -33 18 -72 48 -42 13 13 14 20 6 34 -15 23 -38 26 -54
                      8z" fill='#d8bb6c'/>
                      <path d="M355 279 c-10 -30 19 -53 47 -38 29 15 20 53 -14 57 -20 2 -28 -2
                      -33 -19z" fill='#d8bb6c'/>
                      <path d="M370 165 c0 -30 5 -55 10 -55 6 0 10 25 10 55 0 30 -4 55 -10 55 -5
                      0 -10 -25 -10 -55z"/>
                      <path d="M355 80 c-3 -5 -3 -19 0 -31 10 -31 60 -23 60 11 0 20 -6 26 -27 28
                      -14 2 -29 -2 -33 -8z" fill='#d8bb6c'/>
                    </g>
                  </svg>
                  <div className="">
                    <h1 className='text-[#eaecef] py-2 md:text-lg font-semibold'>
                      Connection
                    </h1>
                    <p className='text-[#B7BDC6] text-sm md:text-base max-w-lg'>
                      This breaks the connection between your previous coins and new coins and it becomes almost impossible to follow the lead.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='hidden md:block lg:block justify-end'>
            <Cricle/>
          </div>
        </div>
      </div>
    </>
  )
}
